export const userRoles = Object.freeze({
  ADMIN: "admin",
  DEBUG: "debug",
  RADPEER_SUPPORT: "radpeer-support",
  SUPPORT: "support",
})

export const apiAccessRoles = Object.freeze({
  FULL: "full",
  TWO_FA: "two-fa",
})

export const isFullScope = (scope = []) => scope.includes(apiAccessRoles.FULL)

export const isTwoFaScope = (scope = []) =>
  scope.includes(apiAccessRoles.TWO_FA)

export const tableViews = Object.freeze({
  BASIC: "basic",
  EXTENDED: "extended",
})

export const bodyParts = Object.freeze({
  SPINE: "Spine",
  BRAIN: "Brain",
  KNEE: "Knee",
  SHOULDER: "Shoulder",
})

export const logsSource = Object.freeze({
  RAMSOFT: "RAMSOFT",
  OUTSIDE_V3: "OUTSIDE V3",
})

export const BREAST_BODY_PART = "Breast"

export const WHOLE_BODY_BODY_PART = "Whole Body"

// Outside V3 stores whole-body scans with this body part value.
export const WHOLE_BODY_STORED_BODY_PART = "fullbodyscan"

export const getBodyPartLabel = (bodyPart) =>
  bodyPart?.toLowerCase() === WHOLE_BODY_STORED_BODY_PART
    ? WHOLE_BODY_BODY_PART
    : bodyPart

export const MAMMOGRAM_LOG_TYPE = "MAMMOGRAM_ILLUSTRATION"

export const sourceTypes = Object.freeze({
  RAMSOFT: "Ramsoft",
  OUTSIDE_V3: "Outside V3",
})

export const sourceOptions = [sourceTypes.RAMSOFT, sourceTypes.OUTSIDE_V3]

export const breastViewTypes = Object.freeze({
  DENSITY: "density",
  DIAGNOSTIC: "diagnostic",
  ULTRASOUND: "ultrasound",
  BIOPSY: "biopsy",
})

export const breastViews = ["All", ...Object.values(breastViewTypes)]

export const dbDateTimeFormat = "yyyy-MM-dd HH:mm:ss.SSS"

export const dbDateFormat = "yyyy-MM-dd"

// Educational video QR-code tracking. Mirrors constants/index.js in the API.
export const scanEventTypes = Object.freeze({
  PAGE_OPEN: "page_open",
  FEEDBACK_STARTED: "feedback_started",
  FEEDBACK_SUBMITTED: "feedback_submitted",
})

// `preview` marks an internal open from the Video Logs page so admin QA is
// excluded from the scan figures the customer sees.
export const scanSources = Object.freeze({
  QR: "qr",
  PREVIEW: "preview",
})

// Educational video *playback* tracking. Mirrors constants/index.js in the API.
export const playerEventTypes = Object.freeze({
  VIDEO_LOADED: "video_loaded",
  VIDEO_STARTED: "video_started",
  PERCENT_REACHED: "percent_reached",
  STEP_REACHED: "step_reached",
  VIDEO_ENDED: "video_ended",
  BROCHURE_PRINTED: "brochure_printed",
  PLAYER_WAITING: "player_waiting",
  PLAYER_READY: "player_ready",
  PLAYER_PLAYED: "player_played",
  PLAYER_PAUSED: "player_paused",
})
